import _pluralize from 'pluralize';

export const pluralize = (count: number, singular: string): string =>
  _pluralize(singular, count);

export const diffItems = <T>(
  oldItems: T[],
  newItems: T[],
  getKey: (item: T) => string,
): { added: T[]; removed: T[] } => {
  const oldKeys = new Set(oldItems.map(getKey));
  const newKeys = new Set(newItems.map(getKey));
  return {
    added: newItems.filter(item => !oldKeys.has(getKey(item))),
    removed: oldItems.filter(item => !newKeys.has(getKey(item))),
  };
};

export const describeCountChange = (
  oldCount: number,
  newCount: number,
  singular: string,
): string | null => {
  if (newCount > oldCount) {
    const count = newCount - oldCount;
    return `Added ${count} ${pluralize(count, singular)}`;
  }
  if (oldCount > newCount) {
    const count = oldCount - newCount;
    return `Removed ${count} ${pluralize(count, singular)}`;
  }
  return null;
};
